<template>
  <svg
    class="custom-icon"
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.80769 4.14286H1.65385C1.01692 4.14286 0.5 4.68686 0.5 5.35714V16.2857C0.5 16.956 1.01692 17.5 1.65385 17.5H10.8846C11.5215 17.5 12.0385 16.956 12.0385 16.2857V15.0714H2.80769V4.14286Z"
    />
    <path d="M10.8846 0.5V5.35714H15.5L10.8846 0.5Z" />
    <path
      d="M9.73077 6.57143V0.5H5.11538C4.47846 0.5 3.96154 1.044 3.96154 1.71429V13.8571H14.3462C14.9831 13.8571 15.5 13.3131 15.5 12.6429V6.57143H9.73077Z"
    />
  </svg>
</template>
